<template>
  <div
    @touchmove="gtouchmove"
    v-bind:class="{ 'append-box': true, hide: hide }"
    v-if="theme == 'newYear2020'"
  >
    <div class="hanzi-box left-box">
      <div class="char-list-box">
        <div class="char-list">
          <div
            :id="item.dom"
            class="char-box"
            v-for="(item, i) in upData"
            v-bind:key="i"
          ></div>
        </div>
      </div>
    </div>
    <div class="hanzi-box right-box">
      <div class="char-list-box">
        <div class="char-list">
          <div
            :id="item.dom"
            class="char-box"
            v-for="(item, i) in downData"
            v-bind:key="i"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const HanziWriter = require("hanzi-writer");
const renData = require("hanzi-writer-data/人");
const shunData = require("hanzi-writer-data/顺");
const jiaData = require("hanzi-writer-data/家");
const baiData = require("hanzi-writer-data/百");
const yeData = require("hanzi-writer-data/业");
const fuData = require("hanzi-writer-data/福");
const duoData = require("hanzi-writer-data/多");
const caiData = require("hanzi-writer-data/财");
const xiData = require("hanzi-writer-data/喜");
const leData = require("hanzi-writer-data/乐");

//上联数据
const upData = [
  {
    dom: "up1",
    data: renData,
  },
  {
    dom: "up2",
    data: shunData,
  },
  {
    dom: "up3",
    data: jiaData,
  },
  {
    dom: "up4",
    data: shunData,
  },
  {
    dom: "up5",
    data: baiData,
  },
  {
    dom: "up6",
    data: yeData,
  },
  {
    dom: "up7",
    data: shunData,
  },
];
//下联数据
const downData = [
  {
    dom: "down1",
    data: fuData,
  },
  {
    dom: "down2",
    data: duoData,
  },
  {
    dom: "down3",
    data: caiData,
  },
  {
    dom: "down4",
    data: duoData,
  },
  {
    dom: "down5",
    data: xiData,
  },
  {
    dom: "down6",
    data: leData,
  },
  {
    dom: "down7",
    data: duoData,
  },
];
import Browser from "@/utils/browser.js";
import store from "@/store/index";
const brow = new Browser();
export default {
  name: "couplet",
  data() {
    return {
      hide: false,
      upData: upData,
      downData: downData,
      theme: store.state.app.theme,
      isMobile: brow.isMobile(),
      isIPad: brow.isIPad(),
      loadedCount: 0,
      totalCount: upData.length + downData.length,
      autoRemove: false,
    };
  },
  mounted() {
    //人顺家顺百业顺
    //福多财多喜乐多
    this.$nextTick(() => {
      try {
        this.startUp(0);
        this.startDown(0);
      } catch {
        false;
      }
    });
  },
  methods: {
    startUp(index) {
      this.createHanzi(upData[index].dom, upData[index].data).then(() => {
        if (index < upData.length - 1) {
          const nIndex = index + 1;
          this.startUp(nIndex);
        }
      });
    },
    startDown(index) {
      this.createHanzi(downData[index].dom, downData[index].data).then(() => {
        if (index < downData.length - 1) {
          const nIndex = index + 1;
          this.startDown(nIndex);
        }
      });
    },
    createHanzi(domId, charData) {
      let size = 90;
      const doc = window.document.documentElement.getBoundingClientRect();
      let height = doc.height,
        width = doc.width;
      const h = height < width ? height : width;
      const scale = h / 720;
      if (h < 720 && h > 375) {
        size = 60 + 30 * scale;
      }
      if (!this.isIPad && this.isMobile) {
        size = 60;
      }
      return HanziWriter.create(domId, null, {
        width: size,
        height: size,
        showOutline: false,
        showCharacter: false,
        strokeColor: "#000000",
        strokeAnimationSpeed: 100, //100 5x normal speed
        delayBetweenStrokes: 5, //5 milliseconds
        charDataLoader: function () {
          return charData;
        },
      })
        .animateCharacter()
        .then(() => {
          ++this.loadedCount;
        });
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    remove() {
      this.hide = true;
      this.$nextTick(() => {
        this.removeAll();
      });
    },
    removeAll() {
      this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 10;
  pointer-events: none;
  &.hide {
    opacity: 0;
  }
  .hanzi-box {
    position: absolute;
    height: auto;
    width: 0.91rem;
    height: 3.105rem;
    top: 50%;
    transform: translateY(-50%);
    overflow: hidden;
    .char-list-box {
      background-image: url(~@/assets/img/theme/new-year-2020/bg.png);
      background-repeat: no-repeat;
      background-size: cover;
      width: 0.91rem;
      // animation: expand 1s linear forwards;
      height: 3.105rem;
      position: relative;
      .char-list {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0.35rem;
      }
    }
    &.left-box {
      left: 10%;
    }
    &.right-box {
      right: 10%;
    }
    .char-box {
      height: 0.35rem;
      line-height: 0.35rem;
      text-align: center;
    }
  }
}
@keyframes expand {
  0% {
    height: 0rem;
  }
  100% {
    height: 3.105rem;
  }
}
@media all and (orientation: portrait) {
  .append-box {
    display: none;
  }
}
</style>